import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", path: "/" },
  { label: "产品分类", path: "/category/children" },
  { label: "选购指南", path: "/article/milk-tablet-buying-guide-complete" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline hover:no-underline"
          >
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-capsule-line text-lg text-background-50"></i>
            </div>
            <span className="text-lg font-semibold whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
              牛奶片库
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => {
              const isActive =
                link.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.path.split("/").slice(0, 2).join("/"));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm whitespace-nowrap transition-colors duration-200 no-underline hover:no-underline ${
                    isActive
                      ? "text-primary-500 font-medium"
                      : scrolled || !isHome
                        ? "text-foreground-700 hover:text-foreground-950"
                        : "text-background-50/90 hover:text-background-50"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/category/children"
              className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 no-underline hover:no-underline"
            >
              <i className="ri-search-line text-sm"></i>
              搜索牛奶片
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm transition-colors no-underline hover:no-underline ${
                    isActive
                      ? "bg-primary-50 text-primary-600 font-medium"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/category/children"
              className="mt-1 px-4 py-3 rounded-lg text-sm font-medium bg-primary-500 text-background-50 text-center no-underline hover:no-underline"
            >
              <i className="ri-search-line mr-1.5"></i>搜索牛奶片
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}